/**
 * @file 组件入口
 * @author eric
 * @date 2020-05-09
 */

import H5Login from './loginV1.vue';
import H5LoginV2 from './loginV2.vue';
import { env, JS2Native } from '@igetcool/base-components';

const SUCCESS_CDEO = 10000;
const FAILE_CDEO = 30000;
const SUCCESS_MSG = 'success';
const FAIL_MSG = 'fail';


export default {
  install(_vue) {
    const H5LoginConstructor = _vue.extend(H5Login);
    const H5LoginConstructorV2 = _vue.extend(H5LoginV2);
    let loginV1;
    let loginV2;
    let instance;

    const createElement = (v) => {
      if (v === 'v2') {
        return new H5LoginConstructorV2({
          el: document.createElement('div'),
        });
      }
      return new H5LoginConstructor({
        el: document.createElement('div'),
      });
    };

    const isApp = env.isApp;

    const loginInApp = async () => {
      const res = await JS2Native({
        name: 'doLogin'
      });
      const userInfo = {};
      if (res.data) {
        userInfo['userId'] = res.data;
        const { data } = await JS2Native({
          name: 'getUserInfo'
        });
        userInfo['DeviceKey'] = data['App-Device-Key'];
        userInfo['DeviceType'] = data['App-Device-Type'];
        userInfo['APPVersion'] = data['App-Version'];
        userInfo['token'] = data['App-Token'];
      }
      const response = {
        code: res.data ? SUCCESS_CDEO : FAILE_CDEO,
        msg: res.data ? SUCCESS_MSG : FAIL_MSG,
        data: res.data ? userInfo : null
      };
      return response;
    };

    const doLoginHandle = async (resolve, reject) => {
      if (isApp) {
        try {
          const response = await loginInApp();
          resolve(response);
        } catch (error) {
          reject({
            code: FAILE_CDEO,
            data: error,
            msg: FAIL_MSG
          });
        }
      } else {
        instance.show = true;
        instance.$on('cancel', () => {
          instance.show = false;
          resolve({
            code: FAILE_CDEO,
            data: null,
            msg: FAIL_MSG
          });
        });
        instance.$on('error',  (res) => {
          reject({
            code: res.code || FAILE_CDEO,
            data: res.data || {},
            msg: res.msg || FAIL_MSG
          });
        });
        instance.$on('login', (data) => {
          instance.show = false;
          resolve({
            code: SUCCESS_CDEO,
            data,
            msg: SUCCESS_MSG
          });
        });
      }
    };

    _vue.prototype.$coolDoLogin = (options) => {
      if (!env.isApp) {
        const { version: loginVersion = 'v1' } = options || {};
        if (loginVersion && options) { delete options.version }
        if (!loginV1 && loginVersion === 'v1') {
          loginV1 = createElement(loginVersion);
          document.body.appendChild(loginV1.$el);
        }
        if (!loginV2 && loginVersion === 'v2') {
          loginV2 = createElement(loginVersion);
          document.body.appendChild(loginV2.$el);
        }
        if (loginVersion === 'v1') { instance = loginV1 }
        if (loginVersion === 'v2') { instance = loginV2 }
        // if(!instance) {
        //   instance = createElement(loginVersion);
        //   document.body.appendChild(instance.$el);
        // }
        for (const key in options) {
          if (options.hasOwnProperty(key)) {
            const value = options[key];
            instance[key] = value;
          }
        }

      }
      return new Promise(doLoginHandle);
    };
  }
};
